import axios from "axios";
// import {getTokenFromLocalStorage} from "../../helpers/localstorage.helper";


export const instance = axios.create({
    withCredentials: true,
    // @ts-ignore
    baseURL: import.meta.env.VITE_SERVER_URL,

})
instance.interceptors.request.use((config) => {
    // const token = getTokenFromLocalStorage()
    //
    //     config.headers.Authorization = `Bearer ${token}`

    return config
})

export interface IResponse<D> {
    data: D
}